/* Velas del Caribe — option 5 "La Experiencia" on Dawn 16.0.0.
   Ported from Mockups/web-velasdelcaribe/opcion-5-experiencia/index.html. Loaded on every page: the header
   parts run everywhere, every home part runs only when its section is on the page. No libraries. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (id) { return document.getElementById(id); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var juega = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };

  /* ---- The catalog, rendered by the VdC Ritual section from Shopify (handles, cents, vdc metafields) ---- */
  var D = { moneda: '{{amount}}', envio: 3, zona: '', velas: 0, clips: {}, colecciones: {}, productos: [] };
  try { var nodo = $('vdc-datos'); if (nodo) D = JSON.parse(nodo.textContent); } catch (e) {}
  var P = D.productos, C = D.colecciones, META = D.envio || 3;
  var porId = {}; P.forEach(function (p) { porId[p.id] = p; });

  /* Money in the shop's own format (money_without_trailing_zeros, as the Liquid prices are). */
  function dinero(centavos) {
    var n = (centavos || 0) / 100;
    var con = function (dec, mil, sep) {
      var s = n.toFixed(dec).split('.'), e = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
      return s[1] && +s[1] ? e + sep + s[1] : e;
    };
    return D.moneda.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, f) {
      if (f === 'amount_no_decimals') return con(0, ',', '.');
      if (f === 'amount_with_comma_separator') return con(2, '.', ',');
      if (f === 'amount_no_decimals_with_comma_separator') return con(0, '.', ',');
      if (f === 'amount_with_apostrophe_separator') return con(2, "'", '.');
      return con(2, ',', '.');
    });
  }

  /* ---- Mood color: the candle's own color mixed into Verde Caribe, never a flat loud color ---- */
  function rgb(hex) { var n = parseInt(String(hex).replace('#', ''), 16) || 0; return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
  function mezcla(a, b, t) { var x = rgb(a), y = rgb(b); return 'rgb(' + x.map(function (v, i) { return Math.round(v + (y[i] - v) * t); }).join(',') + ')'; }

  /* ================= Sound: never plays before a tap, stops for good at the finder ================= */
  var audio = $('musica'), sonido = false, apagadaParaSiempre = false, rampa = null, ctx = null, ganancia = null;
  var VOLUMEN = audio ? clamp((parseFloat(audio.dataset.volumen) || 35) / 100, 0, 1) : 0.35;
  /* The level lives on a Web Audio gain node, because iPhone Safari ignores audio.volume.
     The context is born inside the first tap (encender); audio.volume is only the fallback. */
  function prepararAudio() {
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctx) {
      ctx = new AC();
      ganancia = ctx.createGain();
      ganancia.gain.value = 0;
      ctx.createMediaElementSource(audio).connect(ganancia);
      ganancia.connect(ctx.destination);
    }
    if (ctx.state === 'suspended') ctx.resume();
  }
  function nivel(v) {
    if (ganancia) { if (v === undefined) return ganancia.gain.value; ganancia.gain.value = v; }
    else { if (v === undefined) return audio.volume; audio.volume = v; }
  }
  function fundir(hasta, ms, fin) {
    cancelAnimationFrame(rampa);
    var desde = nivel(), t0 = performance.now();
    (function paso(t) {
      var k = clamp((t - t0) / ms, 0, 1);
      nivel(desde + (hasta - desde) * k);
      if (k < 1) rampa = requestAnimationFrame(paso); else if (fin) fin();
    })(t0);
  }
  /* html.sonando shows the mute buttons ([data-sonido], also the ritual's); they exist only while the music plays. */
  function pintarSonido() {
    root.classList.toggle('sonando', sonido);
    $$('[data-sonido]').forEach(function (b) { b.removeAttribute('aria-pressed'); b.setAttribute('aria-label', 'Silenciar la música'); });
  }
  function encender() {
    if (!audio || apagadaParaSiempre) return;
    sonido = true; pintarSonido();
    prepararAudio();
    nivel(0);
    var p = audio.play();
    if (p && p.catch) p.catch(function () { sonido = false; pintarSonido(); });
    fundir(VOLUMEN, 2600);
  }
  function apagar() {
    apagadaParaSiempre = true;
    if (!sonido) return;
    sonido = false; pintarSonido();
    fundir(0, 900, function () { if (!sonido) audio.pause(); });
  }
  /* The presentation's music ends when "Encuentra Tu Aroma" is a quarter in view; nothing turns it on again on this page. */
  var aroma = $('aroma');
  if (audio && aroma) {
    if (!reduce && 'IntersectionObserver' in window) {
      var aio = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { apagar(); aio.disconnect(); }
      }, { threshold: 0.25 });
      aio.observe(aroma);
    } else {
      var alLlegar = function () {
        var r = aroma.getBoundingClientRect(), alto = window.innerHeight;
        if (Math.min(r.bottom, alto) - Math.max(r.top, 0) >= Math.min(r.height, alto) * 0.25) { apagar(); window.removeEventListener('scroll', alLlegar); }
      };
      window.addEventListener('scroll', alLlegar, { passive: true });
    }
  }
  document.addEventListener('visibilitychange', function () {
    if (!sonido) return;
    /* A hidden tab gets no animation frames, so a fade would never finish: cut at once. */
    if (document.hidden) { cancelAnimationFrame(rampa); nivel(0); audio.pause(); }
    else { prepararAudio(); juega(audio); fundir(VOLUMEN, 1200); }
  });

  /* ================= Entry (shown or skipped before the first paint by the VdC Entrada section) ================= */
  var entrada = $('entrada');
  function entrar(conSonido) {
    if (conSonido) encender();
    entrada.classList.add('sale');
    root.classList.remove('lock', 'intro');
    root.classList.add('entrado');
    setTimeout(function () { entrada.setAttribute('hidden', ''); }, 1100);
    medir();
  }
  if (entrada) {
    $('e-con').onclick = function () { entrar(true); };
    if (!entrada.hidden) $('e-con').focus({ preventScroll: true });
  } else root.classList.add('entrado');

  /* ================= Grid with collection chips (cards are rendered by Liquid) ================= */
  var listas = { rejilla: P, buscador: [] };
  var rejilla = $('rejilla');
  function pintar(filtro) {
    if (!rejilla) return;
    var ids = [];
    $$('.producto', rejilla).forEach(function (a) {
      var si = filtro === 'todas' || a.dataset.col === filtro;
      a.hidden = !si;
      if (si && porId[a.dataset.id]) ids.push(porId[a.dataset.id]);
    });
    listas.rejilla = ids;
    $$('.chip').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.chip === filtro ? 'true' : 'false'); });
  }

  /* ================= Finder: a suggestion from each scent's vdc tags, never its notes ================= */
  var preguntas = [
    { t: '¿Cuándo La Enciendes?', o: [['manana', 'Mañana'], ['tarde', 'Tarde'], ['noche', 'Noche']] },
    { t: '¿Qué Te Transporta?', o: [['playa', 'Playa'], ['bosque', 'Bosque'], ['especias', 'Especias'], ['flores', 'Flores'], ['frutas', 'Frutas']] },
    { t: '¿Suave O Intensa?', o: [['suave', 'Suave'], ['intensa', 'Intensa']] }
  ];
  var respuestas = [];
  /* r = [momento, familia, intensidad]: main family 4, any family 3, moment 2, intensity 1.5 (the mockup's recomendar()). */
  function recomendar(r) {
    var puntos = P.map(function (p, i) {
      var fam = p.familias || [];
      var s = (fam[0] === r[1] ? 4 : fam.indexOf(r[1]) >= 0 ? 3 : 0) + (p.momento === r[0] ? 2 : 0) + (p.intensidad === r[2] ? 1.5 : 0);
      return { p: p, s: s, i: i };
    }).sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    /* Prefer three different collections among equal scores so the suggestion shows range. */
    var elegidas = [], usadas = {};
    puntos.forEach(function (x) { if (elegidas.length < 3 && !usadas[x.p.coleccion] && x.s >= puntos[0].s - 1.5) { elegidas.push(x.p); usadas[x.p.coleccion] = 1; } });
    puntos.forEach(function (x) { if (elegidas.length < 3 && elegidas.indexOf(x.p) < 0) elegidas.push(x.p); });
    return elegidas;
  }
  function nombreCol(p) { return C[p.coleccion] ? C[p.coleccion].nombre : ''; }
  function detalle(p) { return [nombreCol(p), p.tamano].filter(Boolean).join(', '); }
  function pasoBuscador() {
    var caja = $('b-caja'), n = respuestas.length;
    if (n < 3) {
      var q = preguntas[n];
      caja.innerHTML = '<div class="b-paso entra"><div class="b-cuenta">Pregunta ' + (n + 1) + ' de 3</div><h3>' + q.t + '</h3>' +
        '<div class="b-opciones">' + q.o.map(function (o) { return '<button type="button" class="b-op" data-resp="' + o[0] + '">' + o[1] + '</button>'; }).join('') + '</div>' +
        (n ? '<button type="button" class="b-atras" data-atras>Volver A La Pregunta Anterior</button>' : '') + '</div>';
      return;
    }
    var r = recomendar(respuestas); listas.buscador = r;
    caja.innerHTML = '<div class="b-res"><h3>Tus Tres Aromas</h3><p class="b-nota">Es una sugerencia según el nombre de cada aroma y su colección. Toca una vela para conocerla.</p>' +
      '<div class="b-velas">' + r.map(function (p, i) {
        return '<a class="b-vela" href="' + esc(p.url) + '" data-id="' + esc(p.id) + '" style="--n:' + i + '"><span class="foto-vela"><img src="' + esc(p.foto) + '" alt=""></span>' +
          '<h4>' + esc(p.nombre) + '</h4><small>' + esc(detalle(p)) + '</small><div class="precio">' + dinero(p.precio) + '</div></a>';
      }).join('') + '</div><div class="b-acciones"><button type="button" class="btn" data-reinicia>Empezar De Nuevo</button></div></div>';
  }
  if ($('b-caja') && P.length) {
    $('b-caja').addEventListener('click', function (e) {
      var b = e.target.closest('[data-resp],[data-atras],[data-reinicia]'); if (!b) return;
      if (b.dataset.resp) respuestas.push(b.dataset.resp);
      else if (b.hasAttribute('data-atras')) respuestas.pop();
      else respuestas = [];
      pasoBuscador();
      var foco = $('b-caja').querySelector('button,a'); if (foco) foco.focus({ preventScroll: true });
    });
    pasoBuscador();
  }

  /* ================= Mobile menu ================= */
  var abierto = null;
  function bloquear() { root.classList.toggle('lock', !!abierto || ritualAbierto || !!entrada && !entrada.hidden && !entrada.classList.contains('sale')); }
  function abrir(id) {
    cerrar();
    abierto = $(id); if (!abierto) return;
    abierto.classList.add('abierto'); $('velo').classList.add('abierto'); bloquear();
    $$('[data-abre="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var foco = abierto.querySelector('[data-cierra]'); if (foco) foco.focus({ preventScroll: true });
  }
  function cerrar() {
    if (!abierto) return;
    $$('[data-abre="' + abierto.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    abierto.classList.remove('abierto'); $('velo').classList.remove('abierto'); abierto = null; bloquear();
  }
  if ($('velo')) $('velo').addEventListener('click', cerrar);

  /* ================= Cart: Shopify's real cart (AJAX), Dawn's drawer ================= */
  /* The count starts from the badge Liquid rendered ({{ cart.item_count }}, every page); #vdc-datos, and so D.velas, is on home only. */
  var bolsaN = document.querySelector('.cuenta');
  var velas = bolsaN ? parseInt(bolsaN.textContent, 10) || 0 : D.velas || 0;
  var cajon = function () { return document.querySelector('cart-drawer'); };
  /* Free from 1 candle: no counter, the line names the zone (theme setting vdc_envio_zona). */
  function textoEnvio(v) {
    if (META < 2) return 'Envío gratis en ' + D.zona + '.';
    var falta = META - v;
    return v === 0 ? 'El envío es gratis desde ' + META + ' velas.'
      : falta > 0 ? 'Te ' + (falta === 1 ? 'falta 1 vela' : 'faltan ' + falta + ' velas') + ' para el envío gratis.'
      : 'Tu envío es gratis.';
  }
  function pintarCuenta(salto) {
    $$('.cuenta').forEach(function (c) {
      c.textContent = velas;
      if (salto) { c.classList.remove('salto'); void c.offsetWidth; c.classList.add('salto'); }
    });
    if ($('ri-envio')) $('ri-envio').textContent = textoEnvio(velas);
    $$('.tres i').forEach(function (i, k) { i.classList.toggle('on', k < velas); });
  }
  $$('.tres').forEach(function (t) { if (META < 2) t.remove(); else t.innerHTML = new Array(META + 1).join('<i></i>'); });
  function leerCarrito(salto) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { velas = c.item_count; pintarCuenta(salto); return c; });
  }
  /* Swap in Dawn's re-rendered drawer and bag without opening the drawer (the ritual stays in front). */
  function refrescarCajon(secciones) {
    var cd = cajon(), parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
    if (cd && secciones['cart-drawer']) {
      var nuevo = parse(secciones['cart-drawer']).querySelector('#CartDrawer'), viejo = $('CartDrawer');
      if (nuevo && viejo) {
        viejo.innerHTML = nuevo.innerHTML;
        cd.classList.remove('is-empty');
        var velo = $('CartDrawer-Overlay'); if (velo) velo.addEventListener('click', function () { cd.close(); });
      }
    }
    var bolsa = $('cart-icon-bubble');
    if (bolsa && secciones['cart-icon-bubble']) {
      var s = parse(secciones['cart-icon-bubble']).querySelector('.shopify-section');
      if (s) bolsa.innerHTML = s.innerHTML;
    }
  }
  function agregar(p, n) {
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: p.variante, quantity: n }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); })
      .then(function (j) { if (j.sections) refrescarCajon(j.sections); return leerCarrito(true); });
  }
  /* Dawn publishes every change made inside the drawer; keep the counts and the three flames in step. */
  if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { leerCarrito(false); });
  pintarCuenta(false);

  /* ================= Ritual view ================= */
  var ritual = $('ritual'), plato = $('ri-plato'), ritualAbierto = false, ocupado = false;
  var lista = P, indice = 0, origen = null, cant = 1;
  var bocas = { diamante: .03, candlewood: .1, journeyman: .02, elevate: .25 };
  var EASE = 'cubic-bezier(.77,0,.18,1)';

  /* Corner radii of a box, expressed for a clone drawn at another scale (percent stays percent). */
  function radios(el, s) {
    var cs = getComputedStyle(el), w = el.offsetWidth / 2;
    return ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'].map(function (k) {
      var r = cs[k].split(' ')[0];
      return r.indexOf('%') >= 0 ? r : (Math.min(parseFloat(r) || 0, w) / s).toFixed(1) + 'px';
    }).join(' ');
  }
  /* The jar flies from one box to another: a clone sits at the target and is transformed from the source (FLIP). */
  function volar(desde, hasta, alVolver, fin) {
    var a = desde.getBoundingClientRect(), b = hasta.getBoundingClientRect();
    var enPantalla = a.width && a.bottom > 0 && a.top < innerHeight;
    var img = (alVolver ? hasta : desde).querySelector('img') || (alVolver ? desde : hasta).querySelector('img');
    if (reduce || !enPantalla || !b.width || !img || !puedeAnimar()) { fin(); return; }
    var v = document.createElement('div'); v.className = 'vuelo';
    v.innerHTML = '<img src="' + esc(img.getAttribute('src')) + '" alt="">';
    v.style.cssText = 'left:' + b.left + 'px;top:' + b.top + 'px;width:' + b.width + 'px;height:' + b.height + 'px';
    var sx = a.width / b.width, sy = a.height / b.height;
    var ini = 'translate(' + (a.left - b.left) + 'px,' + (a.top - b.top) + 'px) scale(' + sx + ',' + sy + ')';
    var padA = alVolver ? '13%' : '6%', padB = alVolver ? '6%' : '13%';
    document.body.appendChild(v);
    var vi = v.querySelector('img');
    var anim = v.animate([{ transform: ini, borderRadius: radios(desde, sx) }, { transform: 'none', borderRadius: radios(hasta, 1) }], { duration: 900, easing: EASE, fill: 'both' });
    vi.animate([{ padding: padA }, { padding: padB }], { duration: 900, easing: EASE, fill: 'both' });
    anim.onfinish = function () { fin(); requestAnimationFrame(function () { v.remove(); }); };
  }
  function puedeAnimar() { return typeof Element.prototype.animate === 'function'; }
  function cajaOrigen(id) {
    var vh = innerHeight;
    if (origen && origen.dataset.id === id) { var r = origen.getBoundingClientRect(); if (r.bottom > 0 && r.top < vh) return origen.querySelector('.foto-vela'); }
    var cand = $$('[data-id="' + id + '"]:not([hidden]) .foto-vela').filter(function (el) { var r = el.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < vh; });
    return cand[0] || null;
  }
  function llenar(p) {
    ritual.style.setProperty('--mood', mezcla('#0B3522', p.color, .36));
    ritual.style.setProperty('--mood-luz', mezcla('#0B3522', p.color, .9).replace('rgb', 'rgba').replace(')', ',.38)'));
    plato.style.setProperty('--boca', bocas[p.coleccion] || .08);
    $('ri-foto').src = p.foto; $('ri-foto').alt = p.nombre;
    $('ri-pos').textContent = 'Vela ' + (indice + 1) + ' de ' + lista.length;
    $('ri-col').textContent = nombreCol(p) ? 'Colección ' + nombreCol(p) : '';
    $('ri-nombre').textContent = p.nombre;
    $('ri-precio').textContent = dinero(p.precio);
    $('ri-ficha').href = p.url;
    $('ri-tam').textContent = (p.tamano ? p.tamano + ', ' : '') + 'con ITBIS incluido';
    cant = 1; $('ri-cant').textContent = 1;
    var b = $('ri-agregar');
    b.disabled = !p.disponible || !p.variante; b.textContent = b.disabled ? 'Agotada' : 'Agregar Al Carrito';
    var n = p.notas, niveles = n ? [['Salida', n.salida, '46%'], ['Corazón', n.corazon, '70%'], ['Fondo', n.fondo, '94%']].filter(function (r) { return r[1]; }) : [];
    $('ri-notas').innerHTML = niveles.length
      ? '<div class="piramide" aria-label="Notas del aroma">' + niveles.map(function (r, i) { return '<div class="nivel" style="--a:' + r[2] + ';--n:' + i + '"><span>' + r[0] + '</span><strong>' + esc(r[1]) + '</strong></div>'; }).join('') + '</div>'
      : (C[p.coleccion] && C[p.coleccion].desc ? '<p class="ri-desc ri-revela" style="--t:.25s">' + esc(C[p.coleccion].desc) + '</p>' : '') +
        '<p class="ri-sin ri-revela" style="--t:.3s">Pregúntanos por WhatsApp cómo huele: te lo contamos.</p>';
    var clip = D.clips[p.coleccion] || D.clips.candlewood || {};
    $('ri-poster').src = clip.poster || '';
    var v = $('ri-clip');
    if (reduce || !clip.video) { v.removeAttribute('src'); v.style.display = 'none'; }
    else if (v.getAttribute('src') !== clip.video) { v.src = clip.video; v.poster = clip.poster; }
    if (!reduce && ritualAbierto && clip.video) juega(v);
  }
  function reiniciarRevela() { ritual.classList.remove('listo'); void ritual.offsetWidth; ritual.classList.add('listo'); }
  function abrirRitual(id, desde) {
    if (ocupado || !porId[id]) return;
    var cont = desde && desde.closest('[data-lista]');
    lista = cont ? listas[cont.dataset.lista] : P;
    if (lista.indexOf(porId[id]) < 0) lista = P;
    indice = lista.indexOf(porId[id]);
    origen = desde; ritualAbierto = true; ocupado = true;
    llenar(porId[id]);
    ritual.classList.remove('listo', 'cerrando');
    ritual.classList.add('abierto'); bloquear();
    plato.classList.add('oculto-vuelo');
    var caja = desde && desde.querySelector('.foto-vela');
    if (caja) caja.classList.add('en-vuelo');
    if (!reduce && $('ri-clip').getAttribute('src')) juega($('ri-clip'));
    requestAnimationFrame(function () {
      var aterriza = function () {
        plato.classList.remove('oculto-vuelo'); if (caja) caja.classList.remove('en-vuelo');
        ritual.classList.add('listo'); ocupado = false;
        $('ri-cerrar').focus({ preventScroll: true });
      };
      if (caja) volar(caja, plato.querySelector('.foto-vela'), false, aterriza); else aterriza();
    });
  }
  function cerrarRitual() {
    if (!ritualAbierto || ocupado) return;
    ocupado = true;
    var p = lista[indice], destino = cajaOrigen(p.id);
    ritual.classList.add('cerrando'); ritual.classList.remove('listo');
    var termina = function () {
      if (destino) destino.classList.remove('en-vuelo');
      ritual.classList.remove('abierto', 'cerrando'); $('ri-clip').pause();
      ritualAbierto = false; ocupado = false; bloquear();
      if (origen) origen.focus({ preventScroll: true });
    };
    if (destino && !reduce) {
      destino.classList.add('en-vuelo'); plato.classList.add('oculto-vuelo');
      volar(plato.querySelector('.foto-vela'), destino, true, function () { plato.classList.remove('oculto-vuelo'); termina(); });
    } else termina();
  }
  function moverRitual(dir) {
    if (!ritualAbierto || ocupado || lista.length < 2) return;
    indice = (indice + dir + lista.length) % lista.length;
    if (reduce) { llenar(lista[indice]); return; }
    ocupado = true;
    ritual.classList.remove('listo');
    var sale = plato.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateX(' + (-dir * 70) + 'px) scale(.94)', opacity: 0 }], { duration: 320, easing: 'ease-in', fill: 'both' });
    sale.onfinish = function () {
      llenar(lista[indice]);
      var entra = plato.animate([{ transform: 'translateX(' + (dir * 70) + 'px) scale(.94)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 560, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
      entra.onfinish = function () { sale.cancel(); entra.cancel(); reiniciarRevela(); ocupado = false; };
    };
  }
  if (ritual) {
    $('ri-cerrar').onclick = cerrarRitual;
    $('ri-ant').onclick = function () { moverRitual(-1); };
    $('ri-sig').onclick = function () { moverRitual(1); };
    $('ri-menos').onclick = function () { cant = Math.max(1, cant - 1); $('ri-cant').textContent = cant; };
    $('ri-mas').onclick = function () { cant = Math.min(20, cant + 1); $('ri-cant').textContent = cant; };
    $('ri-carrito').onclick = function () { var cd = cajon(); if (cd) cd.open(this); else location.href = (window.routes && window.routes.cart_url) || '/cart'; };
    $('ri-agregar').onclick = function () {
      var p = lista[indice], n = cant, boton = this;
      boton.disabled = true;
      var pedido = agregar(p, n).catch(function (e) {
        $('ri-envio').textContent = 'No pudimos agregarla: ' + e.message + '. Intenta de nuevo.';
      }).then(function () { boton.disabled = !p.disponible; });
      if (reduce || !puedeAnimar()) return;
      /* The jar flies into the bag while the cart call runs; the count bounces when Shopify answers. */
      var a = plato.getBoundingClientRect(), b = $('ri-carrito').getBoundingClientRect();
      var s = a.width * .5, x0 = a.left + a.width * .25, y0 = a.top + a.height * .25;
      var v = document.createElement('div'); v.className = 'vuelo-chico';
      v.innerHTML = '<img src="' + esc(p.foto) + '" alt="">';
      v.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + s + 'px;height:' + s + 'px';
      document.body.appendChild(v);
      var dx = b.left + b.width / 2 - (x0 + s / 2), dy = b.top + b.height / 2 - (y0 + s / 2);
      v.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * .45 + 'px,' + (dy * .45 - 120) + 'px) scale(.55)', opacity: 1, offset: .45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: .4 }
      ], { duration: 950, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'both' }).onfinish = function () { v.remove(); };
      return pedido;
    };
    /* Swipe inside the ritual: a clear horizontal move changes the candle. */
    var toque = null;
    $('ri-escena').addEventListener('pointerdown', function (e) { toque = { x: e.clientX, y: e.clientY }; });
    $('ri-escena').addEventListener('pointerup', function (e) {
      if (!toque) return;
      var dx = e.clientX - toque.x, dy = e.clientY - toque.y; toque = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.4) moverRitual(dx < 0 ? 1 : -1);
    });
  }

  document.addEventListener('keydown', function (e) {
    var drawerAbierto = !!document.querySelector('cart-drawer.active');
    if (e.key === 'Escape' && !drawerAbierto) { if (abierto) cerrar(); else if (ritualAbierto) cerrarRitual(); }
    if (ritualAbierto && !abierto && !drawerAbierto) { if (e.key === 'ArrowRight') moverRitual(1); if (e.key === 'ArrowLeft') moverRitual(-1); }
  });

  /* ================= Clicks across the page ================= */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sonido],[data-abre],[data-cierra],[data-id],[data-col],[data-chip],[data-filtro],.menu-movil a');
    if (!t) return;
    if (t.hasAttribute('data-sonido')) { apagar(); return; }
    if (t.dataset.abre) { abrir(t.dataset.abre); return; }
    if (t.hasAttribute('data-cierra')) { cerrar(); return; }
    /* A candle card is a real product link; with the ritual on the page it opens the ritual instead. */
    if (t.dataset.id) { if (ritual && porId[t.dataset.id]) { e.preventDefault(); abrirRitual(t.dataset.id, t); } return; }
    if (t.dataset.chip) { pintar(t.dataset.chip); return; }
    if (t.dataset.col && t.classList.contains('g-carta') && rejilla) {
      e.preventDefault(); pintar(t.dataset.col); $('todas').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); return;
    }
    if (t.dataset.filtro && rejilla) pintar(t.dataset.filtro);
    if (t.closest('.menu-movil')) cerrar();
  });

  /* ================= Videos: load only when seen, play only in view, never under reduced motion ================= */
  if (!reduce && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) juega(e.target); else e.target.pause(); });
    }, { threshold: 0.15 });
    $$('video[data-auto]').forEach(function (v) { vio.observe(v); });
  }

  /* ================= Scroll: header, wick, day to night, the film, the deck (transform / opacity only) ================= */
  var relato = $('relato'), escenas = $$('.r-carta'), momentos = $$('.momento'), avances = $$('.r-avance i');
  var galeria = $('colecciones'), mazo = $('g-mazo'), cartas = [], hojas = [], dia = $('dia'), linea = $('mecha-linea'), llama = $('mecha-llama');
  var cabecera = document.querySelector('.cabecera');
  var mqPin = window.matchMedia('(min-height: 560px)');
  var finRelato = 1, pinMazo = false, pendiente = false, momentoActual = 0;
  var TRAMO = 0.75; /* scroll per rising card, in screen heights */
  function medir() {
    if (mazo) {
      cartas = $$('.g-carta', mazo); hojas = [].slice.call(mazo.children);
      pinMazo = !reduce && mqPin.matches;
      root.classList.toggle('pin-v', pinMazo);
      hojas.forEach(function (h) { h.style.transform = ''; h.lastElementChild.style.opacity = ''; });
      galeria.style.height = pinMazo ? (innerHeight * (1 + (hojas.length - 1) * TRAMO + 0.5)) + 'px' : '';
    }
    if (relato) finRelato = Math.max(1, relato.getBoundingClientRect().top + scrollY + relato.offsetHeight - innerHeight);
    cuadro();
  }
  function paralaje() {
    var vh = innerHeight;
    cartas.forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var k = clamp((r.top + r.height / 2 - vh / 2) / vh, -1.2, 1.2);
      var foto = c.querySelector('.g-foto img'), tarro = c.querySelector('.g-tarro');
      if (foto) foto.style.transform = 'translate3d(0,' + (k * -40).toFixed(1) + 'px,0) scale(1.18)';
      if (tarro) tarro.style.transform = 'translate3d(0,' + (k * 30).toFixed(1) + 'px,0)';
    });
  }
  /* A deck at step s: each card after the first rises from below; the ones it covers sink a little and dim.
     The last child of each card is its veil. Returns how far each card has risen (0 below, 1 in place). */
  function apilar(hs, s, vh) {
    var n = hs.length - 1, t = hs.map(function (h, i) { return i === 0 ? 1 : clamp(s - (i - 1), 0, 1); });
    hs.forEach(function (h, i) {
      var d = 0; for (var j = i + 1; j <= n; j++) d += t[j];
      var sube = (1 - t[i]) * vh;
      h.style.transform = 'translate3d(0,' + (sube - Math.min(d, 3) * 8).toFixed(1) + 'px,0) scale(' + (1 - Math.min(d, 3) * 0.04).toFixed(4) + ')';
      h.lastElementChild.style.opacity = (Math.min(d, 1.5) * 0.4).toFixed(3);
    });
    return t;
  }
  function cuadro() {
    pendiente = false;
    var y = window.scrollY, vh = innerHeight, vw = innerWidth;
    if (cabecera) { if (y > 80) cabecera.classList.add('chica'); else if (y < 20) cabecera.classList.remove('chica'); }
    if (reduce || !document.body.classList.contains('vdc-inicio')) return;
    var total = Math.max(1, document.documentElement.scrollHeight - vh), p = clamp(y / total, 0, 1);
    if (linea) { linea.style.transform = 'scaleX(' + p.toFixed(4) + ')'; llama.style.setProperty('--x', (p * vw).toFixed(1) + 'px'); }
    if (dia) dia.style.opacity = (1 - clamp(y / finRelato, 0, 1)).toFixed(3);

    /* The film: one arch card per moment, each rising over the one before (the deck below). Only the top card plays;
       the moment on the side switches when its card is half in, and its bar fills while it is the one shown. */
    if (relato && escenas.length) {
      var r = relato.getBoundingClientRect(), k = escenas.length - 1;
      var visible = r.bottom > 0 && r.top < vh;
      var sr = clamp(-r.top / Math.max(1, r.height - vh), 0, 1) * (k + 0.5) - 0.2;
      var tr = apilar(escenas, sr, vh);
      escenas.forEach(function (c, i) {
        var v = c.firstElementChild, debe = visible && tr[i] > 0 && !(i < k && tr[i + 1] >= 1);
        if (debe && v.paused) juega(v);
        else if (!debe && !v.paused) v.pause();
      });
      var m = 0; for (var q = 1; q <= k; q++) if (tr[q] >= 0.5) m = q;
      if (m !== momentoActual) { momentos[momentoActual].classList.remove('activo'); momentos[m].classList.add('activo'); momentoActual = m; }
      avances.forEach(function (a, i) {
        var desde = i === 0 ? -0.2 : i - 0.5, hasta = i === k ? k + 0.3 : i + 0.5;
        a.style.transform = 'scaleX(' + clamp((sr - desde) / (hasta - desde), 0, 1).toFixed(3) + ')';
      });
    }

    if (pinMazo) {
      var g = galeria.getBoundingClientRect();
      apilar(hojas, clamp(-g.top / Math.max(1, g.height - vh), 0, 1) * (hojas.length - 0.5) - 0.2, vh);
    }
    paralaje();
  }
  window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(cuadro); } }, { passive: true });
  window.addEventListener('resize', medir);
  window.addEventListener('load', medir);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);
  medir();

  /* ================= Candle-light pointer ================= */
  var luz = $('luz');
  if (luz && !reduce) {
    var lx = 0, ly = 0, luzPend = false, apaga = null;
    var mover = function () { luzPend = false; luz.style.transform = 'translate3d(' + lx + 'px,' + ly + 'px,0)'; };
    window.addEventListener('pointermove', function (e) {
      lx = e.clientX; ly = e.clientY; luz.classList.add('on');
      if (!luzPend) { luzPend = true; requestAnimationFrame(mover); }
      if (e.pointerType !== 'mouse') { clearTimeout(apaga); apaga = setTimeout(function () { luz.classList.remove('on'); }, 900); }
    }, { passive: true });
    window.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { lx = e.clientX; ly = e.clientY; mover(); luz.classList.add('on'); } }, { passive: true });
    document.addEventListener('mouseleave', function () { luz.classList.remove('on'); });
  }
})();
